import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'
import { withTranslation } from 'react-i18next'
import { Alert, Empty, Modal, Spin, Tag, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

import { GET_CUSTOMER_CLV_QUERY } from './query'
import { SEGMENT_COLORS, SEGMENT_LABELS } from './format'
import Detail from './Detail'

const SegmentTooltipContent = ({ segment, i18n }) => (
  <div style={{ maxWidth: 280 }}>
    <div style={{ marginBottom: 4 }}>
      <Tag color={SEGMENT_COLORS[segment]} style={{ marginRight: 6 }}>
        {SEGMENT_LABELS[segment]}
      </Tag>
    </div>
    <div>{i18n.t(`customerForm.clvSegmentTreatment.${segment}`)}</div>
  </div>
)

SegmentTooltipContent.propTypes = {
  segment: PropTypes.string.isRequired,
  i18n: PropTypes.object.isRequired
}

const SegmentTag = ({ customerId, showInfoIcon, i18n }) => {
  const [open, setOpen] = useState(false)

  const { data, loading, error } = useQuery(GET_CUSTOMER_CLV_QUERY, {
    variables: { customerId },
    skip: !customerId
  })

  const performance =
    (data && data.customer && data.customer.performance) || null
  const segment = (performance && performance.clvSegment) || 'unsegmented'

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    (<span>
      <Tooltip
        title={<SegmentTooltipContent segment={segment} i18n={i18n} />}
        placement="bottom">
        <Tag
          color={SEGMENT_COLORS[segment]}
          style={{ cursor: 'pointer' }}
          onClick={handleOpen}>
          {SEGMENT_LABELS[segment]}
          {showInfoIcon && <InfoCircleOutlined style={{ marginLeft: 4 }} />}
        </Tag>
      </Tooltip>
      <Modal
        title={i18n.t('customerForm.clv')}
        open={open}
        onCancel={handleClose}
        footer={null}
        width={960}
        destroyOnClose>
        {loading && <Spin />}
        {error && <Alert type="error" message={error.message} />}
        {!loading && !error && !performance && (
          <Empty description={i18n.t('customerForm.clvNoData')} />
        )}
        {!loading && !error && performance && <Detail performance={performance} />}
      </Modal>
    </span>)
  );
}

SegmentTag.propTypes = {
  customerId: PropTypes.string.isRequired,
  showInfoIcon: PropTypes.bool,
  i18n: PropTypes.object.isRequired
}

SegmentTag.defaultProps = {
  showInfoIcon: true
}

export default withTranslation('common')(SegmentTag)
